export default __webpack_public_path__ + "static/media/form-anchor.68093cdb.svg";